import React, {useEffect, useState} from 'react';
import {Box, Button, Card, CardContent, FormControl, Grid, Input, InputLabel} from "@deere/fuel-react";
import "../assets/Campaigns.scss";
import {Controller, useForm} from "react-hook-form";
import {toCapitalizeSplitStr} from "../shared/utils";
import {PERIOD_QUESTION, RESPONSE_BY_QUESTION, TITLE_TEXT} from "../shared/Constants";
import {FormText} from "../shared/FormText";

export const CampaignTitleCard = ({currentData, control, onHandleEdit = () => {}, isPublish = false}) => {
    const {reset} = useForm({});
    const [titleValue, setTitleValue] = useState(currentData.title ? currentData.title : `${TITLE_TEXT} for ${toCapitalizeSplitStr(currentData.supplierName)} - ${parseInt(currentData.supplierNumber)}`)
    const [descValue, setDescValue] = useState(currentData.description ? currentData.description : "")

    const supplierValue = `${toCapitalizeSplitStr(currentData.supplierName)} - ${parseInt(currentData.supplierNumber)}`
    const periodValue = `Fiscal Year ${currentData.fiscalYear}, ${currentData.period.description}`

    const handleTitleChange = (value) => {
        setTitleValue(value)
    }

    const handleDescChange = (value) => {
        setDescValue(value)
    }

    useEffect(() => {
        if (currentData) {
            reset({
                titleValue: currentData.title,
                descValue: currentData.description
            });
        }// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [titleValue, descValue]);


    return (
        <Grid item md={12}>
            <Box mt={6} mr={6}>
                <Card>
                    <CardContent>
                        <Box m={2}>
                            <Grid container alignItems="flex-start" spacing={6}>
                                <Grid item md={6}>
                                    <Grid container alignItems="flex-start" spacing={4}>
                                        <Grid item md={12}>
                                            {isPublish ? (
                                                <FormText
                                                    desc={"Title"}
                                                    name={"title"}
                                                    value={titleValue}
                                                    control={control}
                                                />
                                            ) : (
                                                <FormControl fullWidth required>
                                                    <InputLabel htmlFor="campaignTitle">Title</InputLabel>
                                                    <Controller
                                                        rules={{required: true}}
                                                        control={control}
                                                        defaultValue={titleValue}
                                                        value={titleValue}
                                                        name={"campaignTitle"}
                                                        render={({onChange, value}) => (
                                                            <Input fullWidth
                                                                   id="campaignTitle"
                                                                   value={value}
                                                                   onChange={(e) => {
                                                                       onChange(e.target.value)
                                                                       handleTitleChange(e.target.value)
                                                                   }}
                                                            />
                                                        )}
                                                    />
                                                </FormControl>
                                            )}
                                        </Grid>
                                        <Grid item md={12}>
                                            {isPublish ? descValue && (
                                                <FormText
                                                    desc={"Description"}
                                                    name={"description"}
                                                    value={descValue}
                                                    control={control}
                                                />
                                            ) : (
                                                <FormControl fullWidth>
                                                    <InputLabel htmlFor="campaignDesc">
                                                        Description
                                                    </InputLabel>
                                                    <Controller
                                                        rules={{required: false}}
                                                        control={control}
                                                        defaultValue={descValue}
                                                        value={descValue}
                                                        name="campaignDesc"
                                                        render={({onChange, value}) => (
                                                            <Input fullWidth placeholder="Optional Description"
                                                                   id="campaignDesc"
                                                                   value={value}
                                                                   multiline={true}
                                                                   aria-multiline={true}
                                                                   minRows={3}
                                                                   rowsMin={3}
                                                                   onChange={(e) => {
                                                                       onChange(e.target.value);
                                                                       handleDescChange(e.target.value);
                                                                   }}/>
                                                        )}
                                                    />
                                                </FormControl>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={6}>
                                    <Grid container alignItems="flex-start" spacing={2}>
                                        <Grid item md={11}>
                                            <FormText
                                                desc={"Selected Supplier"}
                                                name={"selectedSupplier"}
                                                value={supplierValue}
                                                control={control}
                                            />
                                        </Grid>
                                        <Grid item md={1}>
                                            {!isPublish && (
                                                <Button variant="text" onClick={() => onHandleEdit(0)}>Edit</Button>)}
                                        </Grid>
                                        <Grid item md={12}>
                                            <FormText
                                                desc={PERIOD_QUESTION}
                                                name={"selectedPeriod"}
                                                value={periodValue}
                                                control={control}
                                            />
                                        </Grid>
                                        <Grid item md={12}>
                                            <FormText
                                                desc={RESPONSE_BY_QUESTION}
                                                name={"selectedDate"}
                                                value={currentData.dueDate}
                                                control={control}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Grid>
    )
}
